import { Text } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'

import { TIPOS_ATENDIMENTO_RETIFICAVEIS_RNDS } from './util-retificacaoAtendimento'

type MomentoRetificacao = 'inicial' | 'confirmacaoEdicao'

const fraseAssinaturaPorMomento: Record<MomentoRetificacao, string> = {
  inicial: 'A assinatura do registro será excluída e pode ser necessário assinar um novo documento.',
  confirmacaoEdicao: 'A assinatura do registro será excluída, sendo necessário assinar um novo documento.',
}

interface AlertaRetificacaoAtendimentoTextProps {
  tipoAtendimentoProfissional: TipoAtendimentoProfissional
  momento: MomentoRetificacao
}

export function AlertaRetificacaoAtendimentoText(props: Readonly<AlertaRetificacaoAtendimentoTextProps>) {
  const { tipoAtendimentoProfissional, momento } = props
  const { ASSINATURA_ELETRONICA_ENABLED } = useFlags()

  const tipoAtendimentoEnviaRnds = TIPOS_ATENDIMENTO_RETIFICAVEIS_RNDS.has(tipoAtendimentoProfissional)
  const fraseAssinatura = fraseAssinaturaPorMomento[momento]

  return (
    <Text color='inherit'>
      Todos os registros adicionados, editados e removidos na retificação serão enviados para a base nacional
      {tipoAtendimentoEnviaRnds && ' e para a RNDS'}. {ASSINATURA_ELETRONICA_ENABLED && <>{fraseAssinatura} </>}
      <Text color='inherit' fontWeight='bold'>
        As alterações poderão ser visualizadas na Trilha de Auditoria do PEC e-SUS APS e impressas através do histórico
        do cidadão.
      </Text>
    </Text>
  )
}
